module.exports = __webpack_public_path__ + "static/media/Catalog_Template_B.79c4e4a7.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateProductWizard/images/Catalog_Template_B.JPG
// module id = 1077
// module chunks = 0